export default __webpack_public_path__ + "static/media/room2-MASK-Zahner2.18671eda.png";